module.exports = __webpack_public_path__ + "static/media/MEMBRESIA diamond.377db663.png";